import React from 'react';
import InnerBlock from '../../shared/web/layout/InnerBlock';
import { Cell, CheckboxInput, List, ListDataRefresher, useShowContextRequired } from 'ui-builder';
import {
  TASKS_GROUP_CREATED, TASKS_GROUP_DELETED,
  TASKS_GROUP_UPDATED,
  TasksGroup, TasksGroupPermission,
  useTasksGroupsService
} from 'nekst-api';
import { GridLayout, TasksGroupIcon } from 'features/nekst-widgets';
import { UpdateTasksGroupButton } from './UpdateForm';
import { DeleteGroupButton } from './DeleteForm';
import { CreateTasksGroupButton } from './CreateTasksGroupForm';
import VisibilityFieldLayout from '../projectdetails/shared/VisibilityFieldLayout';

function NameField() {
  const showContext = useShowContextRequired<TasksGroup>();

  return (
    <TasksGroupIcon group={showContext.data!} withName />
  );
}

function VisibilityField() {
  const showContext = useShowContextRequired<TasksGroup>();

  if (!showContext.data!._permissions.includes(TasksGroupPermission.DELETE)) {
     return  (
       <VisibilityFieldLayout value={showContext.data!.isHidden} />
     )
  } else {
    return null;
  }
}

export default function TasksGroupsList() {
  const tasksGroupsService = useTasksGroupsService();

  const [showHidden, setShowHidden] = React.useState(true);

  return (
    <InnerBlock
      title="Tasks Groups"
      headerRight={<CreateTasksGroupButton />}
    >
      <List
        getDataFunc={() => tasksGroupsService.getTasksGroups(showHidden)}
        dependencies={[showHidden]}
      >
        <div style={{ marginBottom: '1rem' }}>
          <CheckboxInput
            source="returnHidden"
            label="Show Hidden Tasks Groups"
            value={showHidden}
            onChangeCallback={() => setShowHidden(!showHidden)}
          />
        </div>
        <GridLayout weights={[10, 2]}>
          <Cell label="Group Name">
            <NameField />
          </Cell>
          <Cell label="Actions">
            <UpdateTasksGroupButton />
            <DeleteGroupButton />
            <VisibilityField />
          </Cell>
        </GridLayout>
        <ListDataRefresher
          eventName={[TASKS_GROUP_CREATED, TASKS_GROUP_UPDATED, TASKS_GROUP_DELETED]}
        />
      </List>
    </InnerBlock>
  );
}
